import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loginbg.mp4'
import _imports_1 from '@/assets/seaLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-037166f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  class: "login_bg_vid",
  autoplay: "",
  loop: "",
  muted: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1))
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo_img",
  src: _imports_1
}, null, -1))
const _hoisted_4 = { class: "login_cont" }
const _hoisted_5 = { class: "ct_div" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_tit" }, "账号", -1))
const _hoisted_7 = { class: "ct_div" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_tit" }, "密码", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_icon, {
            color: "#fff",
            size: "18"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_User)
            ]),
            _: 1
          }),
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            class: "inputs",
            placeholder: "请输入账号",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.names) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.names]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_icon, {
            color: "#fff",
            size: "18"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_User)
            ]),
            _: 1
          }),
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "inputs",
            placeholder: "请输入密码",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passw) = $event)),
            type: "password",
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.passw]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "bts",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)))
      }, "登录")
    ])
  ], 64))
}